module.exports = __webpack_public_path__ + "img/scanner.9262b7e7.png";